"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleClientId = void 0;
const ka = '960171064324-7k4us3vodkc0de81cq6qd4klscv4vvag.apps.googleusercontent.com';
const jp = '542414750901-gd15999shd2c866r0irpik4eos4pm5n3.apps.googleusercontent.com';
function googleClientId(domain) {
    return domain === 'king-an' ? ka : jp;
}
exports.googleClientId = googleClientId;
